import "./App.css";
import Content from "./components/Content";
function App() {
  return (
    <div className="App">
      <div className="main">
        <Content />
      </div>
    </div>
  );
}

export default App;
